import React from 'react';
import { RouteComponentProps } from '@reach/router';
import Page from '../components/Page';

export default (props: RouteComponentProps) => {
  return <Page>ABout Us</Page>;
};
